export default {
  init() {
    var images = document.querySelectorAll('img');
    var options = {
      root: null,      // Page as root
      rootMargin: '0px',
      threshold: 0.1
    };

    var fetchImage = function fetchImage(url) {
      return new Promise(function (resolve, reject) {
        var image = new Image();
        image.src = url;
        image.onload = resolve;
        image.onerror = reject;
      });
    };

    var loadImage = function loadImage(image) {
      var src = image.src;
      fetchImage(src);
    };

    var handleIntersection = function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio > 0) {
          //console.log('Inetresection ... entry', entry.intersectionRatio, entry.target);
          loadImage(entry.target);
        }
      });
    };

    var observer = new IntersectionObserver(handleIntersection, options);
    images.forEach(function (img) {
      observer.observe(img);
    });

    // JavaScript to be fired on all pages
    $(window).on( 'load scroll', function() {
      if ( $(window).scrollTop() > ( $('.header-banner').innerHeight() + 20 ) ) {
        if ( !$('.banner > nav').hasClass('bg-primary') ) {
          $('.banner > nav').toggleClass('bg-primary');
        }
        $('#fixedTryBar').css('top',  $('.banner > nav').css('height')).fadeIn();
      } else {
        $('.banner > nav').removeClass('bg-primary');
        $('#fixedTryBar').fadeOut();
      }
    });
    // $('.widget_nav_menu').clone().appendTo('#navbarSupportedContent');
    // $('.widget_nav_menu').last().toggleClass('d-none d-lg-block');
    window.montlyBroker = function(path) {
      window.open(path,'_blank');
      return true;
    };

    window.dataLayer = window.dataLayer || [];
    //window.dataLayer =  [];
    window.trackBrokerLink = function(brokerName, pagePath, category, dimension26, dimension28, dimension34) {
      if (arguments[1]) {
        const urlWithOutQuery = (arguments[1].split('?',1)).toString();
        var urlWithOutShema = urlWithOutQuery.split('//')[1].toString();
        arguments[1] = urlWithOutShema.substr(urlWithOutShema.indexOf('/'));
        if (arguments[2]) {
          if (urlWithOutShema.lastIndexOf('/') === (urlWithOutShema.length-1)) {
            urlWithOutShema = urlWithOutShema.substr(0,urlWithOutShema.length-1);
          }
          if (urlWithOutShema.lastIndexOf('/') > 1) {
            arguments[2] = '(not set)' + urlWithOutShema.substr(urlWithOutShema.lastIndexOf('/')) + '/(not set)';
          } else {
            arguments[2] = '(not set)' + urlWithOutShema + '/(not set)';
          }
        }
      }
      window.dataLayer.push({
        'ecommerce': {
          'click': {
            'actionField': {
              'list': (arguments[1] !== undefined)? arguments[1] : '/forex-broker-reviews/'}, // Page path or Widget identifier - page path
            'products' :[{
              'name': arguments[0],
              'category': (arguments[2] !== undefined)? arguments[2] : '(not set)/forex-broker-reviews/(not set)',
              'dimension26': (arguments[3] !== undefined)? arguments[3] : 'Page', // 'Page' or 'Widget'
              'dimension28' : (arguments[4] !== undefined)? arguments[4] : 'Button', // 'Button'
              'dimension34' : (arguments[5] !== undefined)? arguments[5] : 'Click'
            }]
          }
        },
        'event':'BrokerClick'});
      console.log('dataLeyer>>>>>>>>>>>',window.dataLayer);
      console.log('dataLeyer-undefined--ver6-->>>>>>>>>>>',dimension34);
    };

    // sticky sidebar
    var $primarySidebar = $('aside.sidebar-primary');
    var $toplistWidget = $primarySidebar.find('.toplist_grid_widget');

    var $sidebarSections = $primarySidebar.find('section');
    var $primarySidebarHeight = 0;
    $sidebarSections.each(function() {
      var $sidebarSectionHeight = $(this).outerHeight(true);
      $primarySidebarHeight += $sidebarSectionHeight;
    });

    if (typeof $toplistWidget.length > 0) {
      var $toplistTop = $toplistWidget.offset().top;
    }

    var $footerTop = $('footer').offset().top;
    var $topNavBarHeight = $('#navbarSupportedContent').outerHeight();
    var $headerButtonsHeight = $('.header-container .header-buttons').outerHeight();

    $(document).scroll(function() {
      if (window.innerWidth >= 992 && $toplistWidget.length > 0) {
        var $toplistScrollTop = ($toplistTop - $(window).scrollTop());
        var $footerScrollTop = ($footerTop - $(window).scrollTop());
        if ( $toplistScrollTop < $topNavBarHeight + $headerButtonsHeight * 2 + 15 && $footerScrollTop > $primarySidebarHeight + $topNavBarHeight + $headerButtonsHeight * 2 + 95 ) {
          $toplistWidget.css({
            'margin-top': $(window).scrollTop() - $toplistTop + $topNavBarHeight + $headerButtonsHeight * 2 + 15,
          });
        }
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('[data-toggle="tooltip"]').tooltip();

    $('a[href^="/"][href*="#"]').on('click', function(){
      var hashtext = "#" + $(this).attr('href').split('#',-1).pop().toLowerCase();
      $("html, body").animate({scrollTop: $(hashtext).offset().top - $('.navbar').height() - 40 }, 500);
    });

    $('.btn-mob-search').on('click', function(e) {
      $(this).find('svg#open').toggleClass('d-none');
      $(this).find('svg#close').toggleClass('d-block');
      e.preventDefault();
      $('#searchBar').toggleClass('d-none d-block');
      var height = $('#searchBar').height();
      $('body > .wrap').css('margin-top', height);
    });

    $(".btn-comments").click(function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $("#fbcomments").offset().top - 180,
      }, 800);
    });

    $('img[class*=wp-image]').toggleClass('wp-image-style');

    const ajaxurl = '/wp-admin/admin-ajax.php'
    if ( $('.input-search').length > 0 ) {
      $('.input-search').typeahead({
        minLength: 1,
        maxItem: 20,
        order: "asc",
        hint: true,
        cancelButton: false,
        href: "{{url}}",
        template: "{{title}}",
        display: ['title'],
        dropdownFilter: [{
          key: 'group',
          template: "Technical Analysis",
          value: "technical_analysis",
          all: "All",
        },{
          key: 'group',
          template: "News",
          value: "news",
          all: "All",
        }],
        source: {
          technical_analysis: {
            ajax: {
              url: ajaxurl + '?action=post_search',
              path: "data.posts.technical_analysis",
            },
          },
          news: {
            ajax: {
              url: ajaxurl + '?action=post_search',
              path: "data.posts.news",
            },
          },
        },
        callback: {
          onNavigateAfter: function (node, lis, a, item, query, event) {
            if (~[38,40].indexOf(event.keyCode)) {
              var resultList = node.closest("form").find("ul.typeahead__list"),
                activeLi = lis.filter("li.active"),
                offsetTop = activeLi[0] && activeLi[0].offsetTop - (resultList.height() / 2) || 0;
              resultList.scrollTop(offsetTop);
            }
          },
          onClickAfter: function (node, a, item) {
            event.preventDefault();
            window.open(item.href, "_self");
            $('#result-container').text('');
          },
          onDropdownFilter: function (node, a, item) {
            const pt = node.next('#searchPostType');
            pt.val(item.value);
          },
          onResult: function (node, query, result) {
            if (query === "") return;
            let text = "";
            if (result.length == 0){
              text = 'No results matching "' + query + '"';
            }
            $('#result-container').html(text);
          },
          onMouseEnter: function (node, a, item) {
            if (item.group === "country") {
              $(a).append('<span class="flag-chart flag-' + item.display.replace(' ', '-').toLowerCase() + '"></span>')
            }
          },
          onMouseLeave: function (node, a) {
            $(a).find('.flag-chart').remove();
          },
        },
      });
    }


    if ( $('input[name="s"]').length > 0 ) {
      $('input[name="s"]').typeahead({
        minLength: 1,
        maxItem: 20,
        order: "asc",
        hint: true,
        dropdownFilter: false,
        cancelButton: false,
        href: "{{url}}",
        template: "{{title}}",
        display: ['title'],
        source: {
          posts: {
            ajax: {
              url: ajaxurl + '?action=content_search',
              path: "data.posts",
            },
          },
        },
        callback: {
          onNavigateAfter: function (node, lis, a, item, query, event) {
            if (~[38,40].indexOf(event.keyCode)) {
              var resultList = node.closest("form").find("ul.typeahead__list"),
                activeLi = lis.filter("li.active"),
                offsetTop = activeLi[0] && activeLi[0].offsetTop - (resultList.height() / 2) || 0;
              resultList.scrollTop(offsetTop);
            }
          },
          onClickAfter: function (node, a, item) {
            event.preventDefault();
            window.open(item.href, "_self");
            $('#result-container').text('');
          },
          onDropdownFilter: function (node, a, item) {
            const pt = node.next('#searchPostType');
            pt.val(item.value);
          },
          onResult: function (node, query, result) {
            if (query === "") return;
            let text = "";
            if (result.length == 0){
              text = 'No results matching "' + query + '"';
            }
            $('#result-container').html(text);
          },
          onMouseEnter: function (node, a, item) {
            if (item.group === "country") {
              $(a).append('<span class="flag-chart flag-' + item.display.replace(' ', '-').toLowerCase() + '"></span>')
            }
          },
          onMouseLeave: function (node, a) {
            $(a).find('.flag-chart').remove();
          },
        },
      });
    }

    // mobile menu dropdown
    if($(window).width() < 992) {
      $('#navbarSupportedContent li').each(function () {
        const dropdown = $(this).find('.dropdown-menu');
        const arrow = $(this).find('svg');
        arrow.on('click', function () {
          $(this).toggleClass('rotate');
          dropdown.toggle();
        });
      });
    }

    // header search widget
    $('#navbarSupportedContent section.search_widget').each(function() {
      $(this).find('a.search-icon').on('click', function(e) {
        e.preventDefault();
        $(this).parent().find('form').toggleClass('d-block');
      });
    });

    // add ID to first image on News post
    $(document).ready( function() {
      let firstNewsImg = $('article.type-news:not(.review) .entry-content img').first();
      if (firstNewsImg) {
        firstNewsImg.attr('id', 'featured');
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js